export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EditStaff.vue?vue&type=template&id=12d4437c"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Crews/EditStaff.vue?vue&type=template&id=12d4437c
// module id = 2527
// module chunks = 31